import { render, staticRenderFns } from "./MyMoveFileList.vue?vue&type=template&id=44d00c68&scoped=true"
import script from "./MyMoveFileList.vue?vue&type=script&lang=js"
export * from "./MyMoveFileList.vue?vue&type=script&lang=js"
import style0 from "./MyMoveFileList.vue?vue&type=style&index=0&id=44d00c68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d00c68",
  null
  
)

export default component.exports